import {Breadcrumb, Col, Divider, Row} from "antd";
import React, {useEffect, useState} from "react";
import axios from "axios";
import Markdown from 'react-markdown'

function About() {

    const [content, setContent] = useState({});

    const [skeleton, setSkeleton] = useState(true);

    const apiKey = process.env.REACT_APP_STRAPI_CMS_API_KEY;

    const toggleSceleton = (value, key) => {
        if (key in value) {
            setSkeleton(false);
        } else {
            setSkeleton(true);
        }
    }

    const getMenu = async () => {
        const response = await axios.get(
            process.env.REACT_APP_STRAPI_URL + "/api/about/?populate=*",
            {
                headers: {
                    'Authorization': 'Bearer ' + apiKey
                }
            }
        )
        console.log(response.data.data.attributes);
        const content = response.data.data.attributes;

        setContent(content);
        toggleSceleton(content, 'Title');
    }

    useEffect(() => {
        getMenu().then(r => {});
    }, []);

    return (<>
        <Row gutter={24} className={"Content"}>
            <Col span={12}>
                <h1>{content.title}</h1>
            </Col>
            <Col span={12} style={{textAlign: "right"}}>
                <Breadcrumb
                    style={{float: "right"}}
                    items={[
                        {
                            href: '/',
                            title: (
                                <>
                                    <span>Home</span>
                                </>
                            ),
                        },
                        {
                            title: 'About',
                        },
                    ]}
                />
            </Col>
        </Row>
            <Row gutter={24} className={"Content"} style={{textAlign: "center", paddingTop: 0}}>
                <Col span={24}>
                    <h2>{content.PageSubTitle}</h2>
                    <Divider className={"TransitionColors"} orientation="left">{content.Quote}</Divider>
                </Col>
            </Row>
            <Row gutter={24} className={"Content"}>
                <Col span={24}>
                    {(content?.blocks ?? []).map((value, key) => {
                        return <Markdown key={key}>{value.body}</Markdown>
                    })}
                </Col>
            </Row>
        </>
    )
}

export default About